{
    "RangeCombo_Search_Placeholder": "Suche...",
    "NAME": "RangeComboLanguage"
}